<template>
  <div class="column gitex__page">
    <div class="container">
      <GitexHeaderGitex/>
      <div class="gitex__section" id="about-dream-flat">
        <div class="gitex__section-body">
          <gitex-hero/>
        </div>
      </div>
      <div class="gitex__section" id="use">
        <div class="gitex__section-title">
          {{ $t('dfIsSolution') }} <br/>
          {{ $t('forEveryone') }}
        </div>
        <div class="gitex__section-body">
          <gitex-solution/>
        </div>
      </div>
      <div class="gitex__section" id="advantages">
        <div class="gitex__section-title">
          {{ $t('mainAdvDf') }}
        </div>
        <div class="gitex__section-body">
          <gitex-advantages/>
        </div>
      </div>
      <div class="gitex__section" id="cases">
        <div class="gitex__section-title">
          {{ $t('examplesOfProj') }} <br/>
          {{ $t('companyName') }}
        </div>
        <div class="gitex__section-body">
          <gitex-gallery/>
        </div>
      </div>
      <div id="tariff" class="gitex__section">
        <GitexTariffs/>

        <UiTariffsInfo
          color="#E31E33"
        />
      </div>
    </div>
    <div class="gitex__section report" id="gallery">
      <div class="gitex__section-body">
        <gitex-photo-report/>
      </div>
    </div>
    <div class="gitex__section for-investors" id="for-investors">
      <div class="gitex__section-body">
        <ForInvestorsComponent
          id="investors"
          color-main="var(--var-crimson-100)"
          bg-btn-color="crimson"
          :li-color-dots="'crimson'"
          email-subject="Gitex Investment"
        />
      </div>
    </div>
    <div class="bg-footer-info">
      <div
        class="container bg-footer-info-box"
        :class="{'row-reverse': rightDir}"
      >
        <div class="mail">hello@dreamflat.design</div>
        <div class="links">
          <a
            v-if="!isDflat"
            href="https://www.instagram.com/dreamflat.design/"
            target="_blank"
          >
            <div class="inst icon"/>
          </a>
          <a
            v-if="!isDflat"
            href="https://www.facebook.com/profile.php?id=100090565989165"
            target="_blank"
          >
            <div class="facebook icon"/>
          </a>
          <a
            v-if="!isDflat"
            href="https://www.linkedin.com/company/93650643/"
            target="_blank"
          >
            <div class="linkedIn icon"/>
          </a>
        </div>
      </div>
    </div>
  </div>
  <ModulesUserLogin
    :show="showLoginModal"
    @update:show="
      $event ? user.showLoginModal() : user.hideLoginModal()
    "
    @hide="user.hideLoginModal"
  />
</template>

<script lang="ts" setup>
import GitexHero from '~/modules/Gitex/components/GitexHero.vue';
import GitexSolution from '~/modules/Gitex/components/GitexSolution.vue';
import GitexAdvantages from '~/modules/Gitex/components/GitexAdvantages.vue';
import GitexGallery from '~/modules/Gitex/components/GitexGallery.vue';
import GitexPhotoReport from '~/modules/Gitex/components/GitexPhotoReport.vue';
import {useUserStore} from '~/modules/User/user.store';
import {useLauncherInfoStore} from '~/store/launcher-info';
import {useI18n} from 'vue-i18n';
import {useDirectionStore} from '~/store/direction.store';
import {useRuntimeConfig} from '#imports';

definePageMeta({
  layout: false,
});

const {t} = useI18n();

useHead({
  title: 'DreamFlat — GITEX Morocco',
  meta: [
    {
      name: 'description',
      content: `${t('gitexHeroDes')}`,
    },
  ],
});
const user = useUserStore();
const launcherInfo = useLauncherInfoStore();
const direction = useDirectionStore();
const rightDir = computed(() => direction.isRight);

const showLoginModal = computed(() => user.isShowLoginModal);
const userInfo = ref({username: ''});

const runtimeConfig = useRuntimeConfig();
const isDflat = runtimeConfig.public.vueAppBaseUrl.includes('d-flat.ru');

user.$subscribe((_, state) => {
  if (!state.error) {
    if (state.isLoggedIn) {
      user.hideLoginModal();
    }
    // user.isLoggedIn = true
    userInfo.value = state;
  }
});

onBeforeMount(async () => {
  const f = async () => await launcherInfo.update();
  await f();
});
</script>

<style scoped lang="scss">
.gitex {
  &__page {
    @media (max-width: $lg) {
      padding-top: 0px;
    }

    .for-investors {
      background-color: var(--var-blue-600);
      padding: $p-24 $p-0;
      margin-bottom: 0px;

      @media (max-width: $lg) {
        padding: $p-10 $p-0;
      }
    }

    .container {
      max-width: 1128px;
      margin: 0 auto;
      @media (max-width: 1160px) {
        max-width: 1024px;
      }
      @media (max-width: $lg) {
        max-width: 100%;
        padding: 0px 16px;
      }
    }

    .report {
      // max-width: 1920px;
      width: 100%;
      margin: 0 auto;
      overflow-x: hidden;
      @media (max-width: 1160px) {
        max-width: 1024px;
      }
      @media (max-width: $lg) {
        max-width: 100%;
        padding: 0px 16px;
      }
    }
  }

  &__section {
    &-body {
      margin-bottom: $m-10;
    }

    &-title {
      font-weight: 700;
      font-size: 36px;
      line-height: 120%;
      letter-spacing: 0.03em;
      color: #3d424a;
      margin-bottom: 40px;
      @media (max-width: $lg) {
        font-size: 24px;
        line-height: 32px;
        letter-spacing: 0.03em;
        margin-bottom: 32px;
        br {
          display: none;
        }
      }
    }

    @media (max-width: $md) {
      margin-top: $m-0;
      margin-bottom: $m-2;
    }
  }

  &__section + &__section--small-mt {
    margin-top: 96px;
    @media (max-width: $lg) {
      margin-top: 128px;
    }
  }
}

.bg-footer-info {
  height: 56px;
  background: var(--var-blue-600);
  border-top: 1px solid var(--var-blue-700);
  align-items: center;

  &-box {
    margin: 0 auto;
    max-width: 1128px;
    width: 100%;
    height: 100%;
    padding: 16px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &.row-reverse {
      flex-direction: row-reverse;
    }

    .mail {
      color: var(--white-theme-white-400, #e1e5f0);
      font-family: Segoe UI;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 140%; /* 22.4px */
      letter-spacing: 0.48px;
    }

    .links {
      display: flex;
      gap: 8px;
      width: auto;
      height: 24px;

      .icon {
        width: 24px;
        height: 24px;
        cursor: pointer;
      }

      .inst {
        background-image: url(assets/cityscape/InstagramLogo.svg);
      }

      .facebook {
        background-image: url(assets/cityscape/cityscape-facebook.svg);
      }

      .linkedIn {
        background-image: url(assets/cityscape/cityscape-linkedin.svg);
      }
    }
  }
}
</style>
